import req from "@/request";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    id: 1,
    config: {},
    detail: {},
    user: {},
    explainList: [],
    jingdian: {},
    initLink: '',
  },
  mutations: {
    SET_DETAIL(state, data) {
      state.detail = data;
    },
    SET_LIST(state, data) {
      state.explainList = data;
    },
    SET_JINGDIAN(state, data) {
      state.jingdian = data;
    },
    SET_CONFIG(state, data) {
      state.config = data;
    },
    SET_USER(state, data) {
      state.user = data;
    },
    setInitLink (state, initLink) {
      state.initLink = initLink
    },
  },
  actions: {
    LoadDetail({ state, commit }) {
      return Promise.all([
        req
          .post("/wx/ScenicInfo", {
            jid: localStorage.getItem("jid"),
          })
          .then((data) => {
            commit("SET_DETAIL", data);
          }),

      ]);

        // req
        //   .post("/wx/appSystemConfig", {
        //     id: state.id,
        //   })
        //   .then((data) => {
        //     commit("SET_CONFIG", data);
        //   }),
     
    },
    LoadExplain({ state, commit }) {
      req
        .post("/wx/weixinproduct", {
          jid: localStorage.getItem("jid"),
          memberId: state.user.id,
          jd_top: localStorage.getItem('jd_top') || "",
        })
        .then((data) => {
          commit("SET_LIST", data);
        });
    },
  },
  modules: {},
});
